"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAuthProviderEnum = exports.AuthProviderEnum = void 0;
var AuthProviderEnum;
(function (AuthProviderEnum) {
    AuthProviderEnum["AWS"] = "aws";
    AuthProviderEnum["INFOAUTH"] = "infoauth";
    AuthProviderEnum["OKTA"] = "okta";
    AuthProviderEnum["MICROSOFT_AD"] = "microsoft-ad";
    AuthProviderEnum["MICROSOFT_AD_INFO_APPS"] = "microsoft-ad-info-apps";
})(AuthProviderEnum = exports.AuthProviderEnum || (exports.AuthProviderEnum = {}));
exports.parseAuthProviderEnum = function (provider) {
    switch (provider) {
        case AuthProviderEnum.AWS:
            return AuthProviderEnum.AWS;
        case AuthProviderEnum.INFOAUTH:
            return AuthProviderEnum.INFOAUTH;
        case AuthProviderEnum.OKTA:
            return AuthProviderEnum.OKTA;
        case AuthProviderEnum.MICROSOFT_AD:
            return AuthProviderEnum.MICROSOFT_AD;
        case AuthProviderEnum.MICROSOFT_AD_INFO_APPS:
            return AuthProviderEnum.MICROSOFT_AD_INFO_APPS;
        default:
            throw new Error('Invalid Authentication Provider: ' + provider);
    }
};
//# sourceMappingURL=provider.enum.js.map